module.exports = __webpack_public_path__ + "static/media/info.76124a75.svg";